import { injectable } from 'inversify';
import { useMainLayoutStore } from '@client/composition/main-layout/application/store/main-layout.store';
import type { MainLayoutStoreQuery } from '@client/composition/main-layout/domain/store/main-layout.store-query';
import type { MainLayoutStoreCommand } from '@client/composition/main-layout/domain/store/main-layout.store-command';
import type { MainLayoutUiModel } from '@client/composition/main-layout/domain/ui-model/main-layout.ui-model';
import type { AtLeastOne } from '@kiplin/web-common/utils';

@injectable()
export class MainLayoutPiniaStoreAdapter implements MainLayoutStoreQuery, MainLayoutStoreCommand {
  private readonly store = useMainLayoutStore();

  public getMainLayoutUiModel(): MainLayoutUiModel {
    return this.store.mainLayoutUiModel;
  }

  public updateMainLayoutUiModel(data: AtLeastOne<MainLayoutUiModel>): void {
    this.store.updateMainLayoutUiModel(data);
  }

  public setIsCustomisationAppModalUiReady(value: boolean): void {
    this.store.setIsCustomisationAppModalUiReady(value);
  }

  public setIsCreateGameModalUiReady(value: boolean): void {
    this.store.setIsCreateGameModalUiReady(value);
  }

  public reset(): void {
    this.store.reset();
  }
}
